import { useEffect, useState } from 'react';
import { api, type ItemLojinha } from '../api';
import { useRota } from '../rota';
import { Moeda } from '../orbita';
import { Foto } from '../componentes/Foto';
import { Carregando } from '../../../compartilhado/Espera';

const ateQuando = (dia: string) => {
  const [, mes, d] = dia.split('-');
  return `até ${d}/${mes}`;
};

/**
 * A tela 3 do mockup: "o que eu consigo trocar?". Prêmio alcançável ganha a
 * borda laranja e o selo preto; o inalcançável fica meio apagado com o
 * "faltam N" — estado claro, como pede a §17.
 */
export function Lojinha({ aoFalhar }: { aoFalhar: (e: unknown) => void }) {
  const { ir } = useRota();
  const [dados, setDados] = useState<{ saldoMoedas: number; recompensas: ItemLojinha[] } | null>(null);
  const [soAlcancaveis, setSoAlcancaveis] = useState(false);
  const [erro, setErro] = useState('');

  useEffect(() => {
    api
      .lojinha()
      .then(setDados)
      .catch((e) => {
        setErro('não consegui carregar a lojinha');
        aoFalhar(e);
      });
  }, [aoFalhar]);

  if (erro) return <div className="erro-tela">{erro}</div>;
  /* Primeira abertura. Os chips de filtro não voltam por aqui: eles peneiram a
     lista que já está em mãos, sem ida ao servidor — logo, nada a cobrir. */
  if (!dados)
    return (
      <div className="espera-tela">
        <Carregando />
      </div>
    );

  const itens = soAlcancaveis ? dados.recompensas.filter((r) => r.alcancavel) : dados.recompensas;

  return (
    <div className="tela lj">
      <h1 className="titulo-tela">lojinha</h1>
      <div className="lj-filtros">
        <button className={soAlcancaveis ? 'chip' : 'chip ativa'} onClick={() => setSoAlcancaveis(false)}>
          Tudo
        </button>
        <button className={soAlcancaveis ? 'chip ativa' : 'chip'} onClick={() => setSoAlcancaveis(true)}>
          Posso resgatar
        </button>
      </div>

      {itens.length === 0 && <div className="lj-vazia">nada por aqui ainda</div>}

      <div className="lj-grade">
        {itens.map((r) => (
          <button
            key={r.id}
            className={r.alcancavel ? 'lj-premio alcancavel' : 'lj-premio'}
            onClick={() => ir(`/recompensa/${r.id}`)}
          >
            {r.vigenciaFim && <span className="lj-ate">{ateQuando(r.vigenciaFim)}</span>}
            <div className={r.alcancavel ? '' : 'lj-apagado'}>
              <Foto capa={r.capa} nome={r.nome} className="lj-foto" />
              <div className="lj-nome">{r.nome}</div>
              <span className={r.alcancavel ? 'selo-custo cheio' : 'selo-custo'}>
                <Moeda tamanho={7} />
                <span>{r.custoMoedas}</span>
              </span>
            </div>
            {!r.alcancavel && (
              <div className="lj-faltam">
                faltam {r.faltam} {r.faltam === 1 ? 'moeda' : 'moedas'}
              </div>
            )}
          </button>
        ))}
      </div>

      <div className="lj-saldo">
        <Moeda tamanho={9} />
        <span>
          você tem {dados.saldoMoedas} {dados.saldoMoedas === 1 ? 'moeda' : 'moedas'}
        </span>
      </div>
    </div>
  );
}
